import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;
const { textLObj } = typographyStyles;

export const anchorCss: CSSObject = {
  textDecoration: "unset",
  "&:hover, :focus": {
    textDecoration: "underline",
  },
  color: ui.core[700],
  ...textLObj,
};
